import { render, staticRenderFns } from "./NoticeboardDetailCard.vue?vue&type=template&id=672e755b&scoped=true"
import script from "./NoticeboardDetailCard.vue?vue&type=script&lang=js"
export * from "./NoticeboardDetailCard.vue?vue&type=script&lang=js"
import style0 from "./NoticeboardDetailCard.vue?vue&type=style&index=0&id=672e755b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e755b",
  null
  
)

export default component.exports